module.exports = __webpack_public_path__ + "static/media/Warning_icn.87ada7b6.svg";